import { TcpaDefaults, TcpaActionTypes } from './TCPAConstants';

export default (state = TcpaDefaults, action) => {
  switch (action.type) {
    case TcpaActionTypes.GRID_RELOAD:
      return Object.assign({}, state, {
        grid: Object.assign({}, state.grid, action.payload),
      });

    case TcpaActionTypes.GRID_RELOADED_LIST:
      return Object.assign({}, state, {
        grid: Object.assign({}, state.grid, action.payload),
      });

    case TcpaActionTypes.GRID_PERMISSION:
      return Object.assign({}, state, {
        grid: Object.assign({}, state.grid, action.payload),
      });

    case TcpaActionTypes.GRID_SORT:
      return Object.assign({}, state, {
        grid: Object.assign({}, state.grid, action.payload),
      });

    case TcpaActionTypes.GRID_SEARCH:
      return Object.assign({}, state, {
        grid: Object.assign({}, state.grid, action.payload),
      });

    case TcpaActionTypes.EDITOR_SHOW:
      return Object.assign({}, state, {
        editor: { ...action.payload },
      });

    case TcpaActionTypes.EDITOR_HIDE:
      return Object.assign({}, state, {
        editor: { ...action.payload },
      });

    case TcpaActionTypes.ALERT_DISPLAY:
      return Object.assign({}, state, {
        alert: { ...action.payload },
      });
  }

  return state;
};
